__turbopack_context__.v({
  "draw": "cert-blocs-module__H8JXSa__draw",
  "drawn": "cert-blocs-module__H8JXSa__drawn",
  "list": "cert-blocs-module__H8JXSa__list",
  "mark": "cert-blocs-module__H8JXSa__mark",
});
